import { ComboField } from '@components/Fields/ComboField';
import { FilterBar } from '@components/FilterBar';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { PrimaryButton } from '@components/Buttons/PrimaryButton';
import { IFilter } from '@hooks/useFilter';
import { IModalWindow } from '@hooks/useModalWindow';
import { MenuItem } from '@material-ui/core';
import { EnumClienteEventoStatus, IComboClienteEventoStatus } from '@model/ClienteEventoStatus';
import { EnumClienteEventoTipo, IComboClienteEventoTipo } from '@model/ClienteEventoTipo';
import { IClienteEventoFilter } from '@services/ClienteService';
import React from 'react';

export type EventoFilterProps = {
    filter: IFilter<IClienteEventoFilter> 
    isLoading: boolean 
    clienteEventoTipoCombo: IComboClienteEventoTipo 
    clienteEventoStatusCombo: IComboClienteEventoStatus
    registrarModal: IModalWindow
}

export function EventoFilter ({ filter, isLoading, registrarModal, clienteEventoTipoCombo, clienteEventoStatusCombo}: EventoFilterProps) {
    const { fields } = filter;

    return (
        <FilterBar>
            <GridItem>
                <PrimaryButton onClick={registrarModal.open}>Novo Evento</PrimaryButton>
            </GridItem>

            <GridItem floatRight>
                <HorizontalGrid spacing={1}>
                    <GridItem>
                        <ComboField
                            field={fields.clienteEventoTipo}
                            disabled={isLoading}
                            updateFieldStateOnChange
                            onValueChanged={(value: EnumClienteEventoTipo) => {
                                if (value !== fields.clienteEventoTipo.value) {
                                    filter.handleFilterRequest();
                                }
                            }}
                        >
                            <MenuItem key={0} value={EnumClienteEventoTipo.None}>Tipo: Todos</MenuItem>
                            {
                                clienteEventoTipoCombo.createOptions({
                                    prefix: "Tipo: "
                                })
                            }
                        </ComboField>
                    </GridItem>

                    <GridItem>
                        <ComboField
                            field={fields.clienteEventoStatus}
                            disabled={isLoading}
                            updateFieldStateOnChange
                            onValueChanged={(value: EnumClienteEventoStatus) => {
                                if (value !== fields.clienteEventoStatus.value) {
                                    filter.handleFilterRequest();
                                }
                            }}
                        >
                            <MenuItem key={0} value={EnumClienteEventoStatus.None}>Status: Todos</MenuItem>
                            {
                                clienteEventoStatusCombo.createOptions({
                                    prefix: "Status: "
                                })
                            }
                        </ComboField>
                    </GridItem>
                </HorizontalGrid>
            </GridItem>
        </FilterBar>
    )
}